import config from 'config'
import { getChannel } from './channel'

/**
 * Checks if the price meets the minimum order requirement.
 * WDV-2179 and WDV-3108
 *
 * @param price - The price to be checked.
 * @returns A boolean indicating whether the price meets the minimum order requirement.
 */
export function notReached(price: number) {
  const { orderMinimumB2B, orderMinimumB2C } = config
  const channel = getChannel()

  if (orderMinimumB2B && channel === 'b2b' && orderMinimumB2B > price)
    return true
  if (orderMinimumB2C && channel === 'b2c' && orderMinimumB2C > price)
    return true
  return false
}

export function value() {
  const { orderMinimumB2B, orderMinimumB2C } = config
  const channel = getChannel()

  if (channel === 'b2b') {
    return orderMinimumB2B
  }
  if (channel === 'b2c') {
    return orderMinimumB2C
  }
  return 0
}
